import React from 'react'

function FreightPage() {
    return (
        <div></div>
    )
}

export default FreightPage